import { useContext, createContext } from 'react'
import {
  DefaultTheme,
  DeviceSupportTheme,
  HNTheme,
  DirecTVTheme,
  TechExpertTheme,
  TmoPghTheme,
  XtdpTheme,
  VodafonePortugalTheme,
} from 'src/Styles/theme'
import { WhiteLabelSources } from 'src/white-label/WhiteLabelSources'
import { AppBrandingSources } from 'src/white-label/AppBrandingSources'
import animationDataDefault from 'src/Animations/SpeedCheckRunAnimation/animationDefault'
import animationDataVodafone from 'src/Animations/SpeedCheckRunAnimation/animationVodafone'
import animationDataHarveyNorman from 'src/Animations/SpeedCheckRunAnimation/animationHarveyNorman'
import { animationDirectv } from 'src/Animations/SpeedCheckRunAnimation/animationDirectv'
import { animationDataTechExpert } from 'src/Animations/SpeedCheckRunAnimation/animationTechExpert'
import animationTmoHome from 'src/Animations/SpeedCheckRunAnimation/animationTmoHome'
import infiniteAnimationDataDefault from 'src/Animations/SpeedCheckInfiniteAnimation/rocketInfiniteDefault'
import infiniteAnimationDataVodafone from 'src/Animations/SpeedCheckInfiniteAnimation/rocketInfiniteVodafone'
import infiniteAnimationDataHarveyNorman from 'src/Animations/SpeedCheckInfiniteAnimation/rocketInfiniteHarveyNorman'
import { rocketinfiniteDirectv } from 'src/Animations/SpeedCheckInfiniteAnimation/rocketInfiniteDirectv'
import { rocketInfiniteTechExpert } from 'src/Animations/SpeedCheckInfiniteAnimation/rocketInfiniteTechExpert'
import rocketInfiniteTmoHome from 'src/Animations/SpeedCheckInfiniteAnimation/rocketInfiniteTmoHome'
import rocketInfiniteXtdp from 'src/Animations/SpeedCheckInfiniteAnimation/rocketInfiniteXtdp'
import animationXtdp from 'src/Animations/SpeedCheckRunAnimation/animationXtdp'
import { animationDataVodafonePortugal } from 'src/Animations/SpeedCheckRunAnimation/animationVodafonePortugal'
import { rocketInfiniteVodafonePortugal } from 'src/Animations/SpeedCheckInfiniteAnimation/rocketInfiniteVodafonePortugal'

interface GetWhiteLabelProps {
  app_branding: string
}

export const getWhiteLabel = ({ app_branding }: GetWhiteLabelProps) => {
  let whiteLabel = WhiteLabel_PG
  if (app_branding) {
    whiteLabels.forEach((item) => {
      if (app_branding === item.brandingKey) {
        whiteLabel = item
      }
    })
  }
  return whiteLabel
}

const DefaultWhiteLabel = {
  theme: DefaultTheme,
  code: WhiteLabelSources.PG_MOBILE,
  brandingKey: AppBrandingSources.OTHER,
  versionCode: '3',
  animationData: animationDataDefault,
  infiniteAnimationData: infiniteAnimationDataDefault,
}

type WhiteLabel = typeof DefaultWhiteLabel

const WhiteLabel_PG: WhiteLabel = DefaultWhiteLabel
const WhiteLabel_ASSURANT_TECH_PRO: WhiteLabel = {
  ...DefaultWhiteLabel,
  code: WhiteLabelSources.ASSURANT_TECH_PRO,
  brandingKey: AppBrandingSources.ASSURANT_TECH_PRO,
}

const WhiteLabel_VODA: WhiteLabel = {
  ...DefaultWhiteLabel,
  theme: DeviceSupportTheme,
  code: WhiteLabelSources.DEVICE_SUPPORT,
  brandingKey: AppBrandingSources.VODAFONE,
  versionCode: '5',
  animationData: animationDataVodafone,
  infiniteAnimationData: infiniteAnimationDataVodafone,
}

const WhiteLabel_HN: WhiteLabel = {
  ...DefaultWhiteLabel,
  theme: HNTheme,
  code: WhiteLabelSources.HARVEY_NORMAN,
  brandingKey: AppBrandingSources.HARVEY_NORMAN,
  versionCode: '10',
  animationData: animationDataHarveyNorman,
  infiniteAnimationData: infiniteAnimationDataHarveyNorman,
}

const WhiteLabel_DIRECTV: WhiteLabel = {
  ...DefaultWhiteLabel,
  theme: DirecTVTheme,
  code: WhiteLabelSources.DIRECTV,
  brandingKey: AppBrandingSources.DIRECTV,
  versionCode: '11',
  animationData: animationDirectv,
  infiniteAnimationData: rocketinfiniteDirectv,
}

const WhiteLabel_TECH_EXPERT: WhiteLabel = {
  ...DefaultWhiteLabel,
  theme: TechExpertTheme,
  code: WhiteLabelSources.TECH_EXPERT,
  brandingKey: AppBrandingSources.TECH_EXPERT,
  versionCode: '12',
  animationData: animationDataTechExpert,
  infiniteAnimationData: rocketInfiniteTechExpert,
}

const WhiteLabel_TMO_HOME: WhiteLabel = {
  ...DefaultWhiteLabel,
  theme: TmoPghTheme,
  code: WhiteLabelSources.TMO_PGH,
  brandingKey: AppBrandingSources.TMO_PGH,
  versionCode: '12',
  animationData: animationTmoHome,
  infiniteAnimationData: rocketInfiniteTmoHome,
}

const WhiteLabel_XTDP: WhiteLabel = {
  ...DefaultWhiteLabel,
  theme: XtdpTheme,
  code: WhiteLabelSources.XTDP,
  brandingKey: AppBrandingSources.XTDP,
  versionCode: '18',
  animationData: animationXtdp,
  infiniteAnimationData: rocketInfiniteXtdp,
}

const WhiteLabel_VODAFONE_PORTUGAL: WhiteLabel = {
  ...DefaultWhiteLabel,
  theme: VodafonePortugalTheme,
  code: WhiteLabelSources.VODAFONE_PORTUGAL,
  brandingKey: AppBrandingSources.VODAFONE_PORTUGAL,
  versionCode: '12',
  animationData: animationDataVodafonePortugal,
  infiniteAnimationData: rocketInfiniteVodafonePortugal,
}

const whiteLabels: WhiteLabel[] = [
  WhiteLabel_PG,
  WhiteLabel_VODA,
  WhiteLabel_HN,
  WhiteLabel_DIRECTV,
  WhiteLabel_TECH_EXPERT,
  WhiteLabel_ASSURANT_TECH_PRO,
  WhiteLabel_TMO_HOME,
  WhiteLabel_XTDP,
  WhiteLabel_VODAFONE_PORTUGAL,
]

export const defaultWhiteLabel = WhiteLabel_PG

export const WhiteLabelContext = createContext<WhiteLabel>(defaultWhiteLabel)

export const useWhiteLabel = () => useContext(WhiteLabelContext)
